import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { fmtNyShort } from "./prepDates";

// Shared column-header rendering for a student across the prep matrices (exam / homework /
// library-test). The name carries the consultation number in parentheses — "Alex Kim (1012)" —
// and a small info icon in the top-right corner opens the ETT-email info modal (replacing the
// old email-on-hover tooltip).

// "Alex Kim (1012)" when a consultation number exists, otherwise just the name (or email).
export const studentLabel = (s) =>
    s?.consultation_number != null && s?.consultation_number !== ""
        ? `${s.name || s.email} (${s.consultation_number})`
        : s?.name || s?.email || "";

// A student whose enrollment — or whose course — has ended keeps their column: the rounds and
// scores behind it are history an admin still needs to read. Label them so an empty column reads
// as "left the course" rather than "did nothing". NY-zone formatting (fmtNyShort) — local Date
// getters would show the previous day for admins west of UTC.
export const enrollmentEndedLabel = (s) => {
    if (s?.enrollment_status !== "ended") return null;
    const when = fmtNyShort(s.enrollment_ended_at);
    return when ? `Ended ${when}` : "Ended";
};

// Header-cell content: centered "Name (number)" with the info icon pinned to the top-right.
// `onInfo(student)` opens the modal — the parent owns the open state.
export const StudentHeaderContent = ({ student, onInfo }) => (
    <Box sx={{ position: "relative", px: 1.5 }}>
        <Box component="span" sx={student?.enrollment_status === "ended" ? { color: "text.disabled" } : undefined}>
            {studentLabel(student)}
        </Box>
        {student?.enrollment_status === "ended" && (
            <Box
                component="span"
                sx={{
                    display: "block", mt: 0.25, fontSize: 10, fontWeight: 400,
                    lineHeight: 1.2, letterSpacing: ".04em", color: "text.disabled",
                }}
            >
                {enrollmentEndedLabel(student)}
            </Box>
        )}
        <Tooltip title="ETT info" arrow>
            <IconButton
                size="small"
                aria-label="ETT info"
                onClick={(e) => {
                    e.stopPropagation();
                    onInfo(student);
                }}
                sx={{ position: "absolute", top: -6, right: -8, p: 0.25, color: "text.secondary" }}
            >
                <InfoOutlinedIcon sx={{ fontSize: 16 }} />
            </IconButton>
        </Tooltip>
    </Box>
);
